export const POINTS_TO_MXN_KEY = 'points_to_mxn';
export const SIMULATION_AMOUNT = 100;
export const LOGO_LIGHT_KEY = 'logo_light';
export const LOGO_DARK_KEY = 'logo_dark';
export const LOGO_ICON_KEY = 'logo_icon';
export const DEVICE_MOCKUP_IMAGE_KEY = 'device_mockup_image';
export const APP_STORE_URL_KEY = 'app_store_url';
export const GOOGLE_PLAY_URL_KEY = 'google_play_url';
